import clsx from 'clsx';
import React, {useState} from 'react';

const renderTabItem = data => {
  return (
    <div className="single-product__descriptions">
      {/* <h3>{data}</h3> */}
      <div className="single-product__descriptions-block">
        <h3 className="single-product__descriptions-title">
          {data.subTitle ?? data.title}
        </h3>
        <ul className="list map">
          <li>{data.desc}</li>
        </ul>
      </div>
      <div className="single-product__descriptions-block">
        <h3 className="single-product__descriptions-title">Телефони:</h3>
        <ul className="list phone">
          <li>
            <a
              style={{width: 'fit-content', display: 'block'}}
              href="tel: +380673601200">
              <div>
                +38 067 360-12-00
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.6095 1.75395C15.1631 1.34262 13.356 0.0312915 9.32712 0.0137134C9.32712 0.0137134 4.57751 -0.271052 2.26423 1.85239C0.977514 3.13911 0.523998 5.027 0.474779 7.36489C0.42556 9.70278 0.365795 14.0833 4.58806 15.2715H4.59158L4.58806 17.0856C4.58806 17.0856 4.55994 17.8204 5.04509 17.968C5.62869 18.1508 5.97322 17.5918 6.5322 16.9907C6.83806 16.6602 7.25994 16.1751 7.57986 15.8059C10.4697 16.0485 12.6881 15.493 12.9412 15.4122C13.5248 15.2223 16.826 14.8004 17.3603 10.42C17.9158 5.89887 17.0931 3.04418 15.6095 1.75395ZM16.0982 10.0895C15.6447 13.7458 12.9693 13.9778 12.4771 14.136C12.2662 14.2028 10.315 14.6879 7.86462 14.5297C7.86462 14.5297 6.0365 16.734 5.46697 17.3071C5.28064 17.4934 5.07673 17.4758 5.08025 17.1067C5.08025 16.8641 5.09431 14.0938 5.09431 14.0938C5.0908 14.0938 5.0908 14.0938 5.09431 14.0938C1.5154 13.1024 1.72634 9.37231 1.76501 7.42114C1.80369 5.46997 2.17283 3.87036 3.26267 2.79457C5.22087 1.01918 9.2533 1.28285 9.2533 1.28285C12.6599 1.29692 14.2912 2.32348 14.6709 2.66801C15.926 3.74379 16.5658 6.31723 16.0982 10.0895ZM11.2115 7.24887C11.2256 7.55122 10.772 7.57231 10.758 7.26997C10.7193 6.49653 10.3572 6.12036 9.61189 6.07817C9.30955 6.06059 9.33767 5.60708 9.6365 5.62465C10.6174 5.67739 11.1623 6.23989 11.2115 7.24887ZM11.9252 7.64614C11.9603 6.15551 11.0287 4.98833 9.26033 4.85825C8.9615 4.83715 8.99314 4.38364 9.29197 4.40473C11.331 4.55239 12.4174 5.95512 12.3787 7.65669C12.3752 7.95903 11.9181 7.94497 11.9252 7.64614ZM13.5775 8.11723C13.581 8.41958 13.124 8.42309 13.124 8.12075C13.1029 5.25551 11.1939 3.69457 8.87712 3.677C8.5783 3.67348 8.5783 3.22348 8.87712 3.22348C11.4681 3.24106 13.5529 5.03051 13.5775 8.11723ZM13.1802 11.5661V11.5731C12.8006 12.2411 12.0904 12.9793 11.3592 12.7438L11.3521 12.7333C10.6103 12.5258 8.86306 11.6258 7.75915 10.7469C7.18962 10.2969 6.66931 9.76606 6.26853 9.2563C5.90642 8.80278 5.5408 8.26489 5.18572 7.61802C4.43689 6.2645 4.27165 5.65981 4.27165 5.65981C4.03611 4.92856 4.77087 4.2184 5.44236 3.83872H5.44939C5.77283 3.66997 6.0822 3.72622 6.28962 3.97583C6.28962 3.97583 6.72556 4.49614 6.91189 4.75278C7.08767 4.99184 7.32322 5.37504 7.44626 5.5895C7.66072 5.9727 7.52712 6.36294 7.31619 6.52466L6.89431 6.86216C6.67986 7.03442 6.70798 7.35434 6.70798 7.35434C6.70798 7.35434 7.33377 9.72036 9.67166 10.318C9.67166 10.318 9.99158 10.3461 10.1638 10.1317L10.5013 9.70981C10.6631 9.49888 11.0533 9.36528 11.4365 9.57973C11.9533 9.87153 12.6107 10.325 13.0467 10.7364C13.2927 10.9368 13.349 11.2426 13.1802 11.5661Z"
                    fill="#7462E5"
                  />
                </svg>
              </div>
              <div>(Вантажний відділ)</div>
            </a>
          </li>
          <li>
            <a
              href="tel: +380933116983"
              style={{width: 'fit-content', display: 'block'}}>
              <div>
                +38 093 311-69-83
                {/* <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.6095 1.75395C15.1631 1.34262 13.356 0.0312915 9.32712 0.0137134C9.32712 0.0137134 4.57751 -0.271052 2.26423 1.85239C0.977514 3.13911 0.523998 5.027 0.474779 7.36489C0.42556 9.70278 0.365795 14.0833 4.58806 15.2715H4.59158L4.58806 17.0856C4.58806 17.0856 4.55994 17.8204 5.04509 17.968C5.62869 18.1508 5.97322 17.5918 6.5322 16.9907C6.83806 16.6602 7.25994 16.1751 7.57986 15.8059C10.4697 16.0485 12.6881 15.493 12.9412 15.4122C13.5248 15.2223 16.826 14.8004 17.3603 10.42C17.9158 5.89887 17.0931 3.04418 15.6095 1.75395ZM16.0982 10.0895C15.6447 13.7458 12.9693 13.9778 12.4771 14.136C12.2662 14.2028 10.315 14.6879 7.86462 14.5297C7.86462 14.5297 6.0365 16.734 5.46697 17.3071C5.28064 17.4934 5.07673 17.4758 5.08025 17.1067C5.08025 16.8641 5.09431 14.0938 5.09431 14.0938C5.0908 14.0938 5.0908 14.0938 5.09431 14.0938C1.5154 13.1024 1.72634 9.37231 1.76501 7.42114C1.80369 5.46997 2.17283 3.87036 3.26267 2.79457C5.22087 1.01918 9.2533 1.28285 9.2533 1.28285C12.6599 1.29692 14.2912 2.32348 14.6709 2.66801C15.926 3.74379 16.5658 6.31723 16.0982 10.0895ZM11.2115 7.24887C11.2256 7.55122 10.772 7.57231 10.758 7.26997C10.7193 6.49653 10.3572 6.12036 9.61189 6.07817C9.30955 6.06059 9.33767 5.60708 9.6365 5.62465C10.6174 5.67739 11.1623 6.23989 11.2115 7.24887ZM11.9252 7.64614C11.9603 6.15551 11.0287 4.98833 9.26033 4.85825C8.9615 4.83715 8.99314 4.38364 9.29197 4.40473C11.331 4.55239 12.4174 5.95512 12.3787 7.65669C12.3752 7.95903 11.9181 7.94497 11.9252 7.64614ZM13.5775 8.11723C13.581 8.41958 13.124 8.42309 13.124 8.12075C13.1029 5.25551 11.1939 3.69457 8.87712 3.677C8.5783 3.67348 8.5783 3.22348 8.87712 3.22348C11.4681 3.24106 13.5529 5.03051 13.5775 8.11723ZM13.1802 11.5661V11.5731C12.8006 12.2411 12.0904 12.9793 11.3592 12.7438L11.3521 12.7333C10.6103 12.5258 8.86306 11.6258 7.75915 10.7469C7.18962 10.2969 6.66931 9.76606 6.26853 9.2563C5.90642 8.80278 5.5408 8.26489 5.18572 7.61802C4.43689 6.2645 4.27165 5.65981 4.27165 5.65981C4.03611 4.92856 4.77087 4.2184 5.44236 3.83872H5.44939C5.77283 3.66997 6.0822 3.72622 6.28962 3.97583C6.28962 3.97583 6.72556 4.49614 6.91189 4.75278C7.08767 4.99184 7.32322 5.37504 7.44626 5.5895C7.66072 5.9727 7.52712 6.36294 7.31619 6.52466L6.89431 6.86216C6.67986 7.03442 6.70798 7.35434 6.70798 7.35434C6.70798 7.35434 7.33377 9.72036 9.67166 10.318C9.67166 10.318 9.99158 10.3461 10.1638 10.1317L10.5013 9.70981C10.6631 9.49888 11.0533 9.36528 11.4365 9.57973C11.9533 9.87153 12.6107 10.325 13.0467 10.7364C13.2927 10.9368 13.349 11.2426 13.1802 11.5661Z"
                  fill="#7462E5"
                />
              </svg> */}
              </div>
              <div>(Відділ електротранспорту)</div>
            </a>
          </li>
          <li>
            <a
              href="tel: +380631127425"
              style={{width: 'fit-content', display: 'block'}}>
              <div>+38 063 112-74-25</div>
              <div>(Легковий відділ) </div>
            </a>
          </li>
          <li>
            <a
              href="tel: +380636027250"
              style={{width: 'fit-content', display: 'block'}}>
              <div>+38 063 602-72-50</div>
              <div>(Альтернативна енергетика)</div>
            </a>
          </li>
          <li>
            <a
              href="tel: +380500860585"
              style={{width: 'fit-content', display: 'block'}}>
              <div>+38 050 086-05-85</div>
              <div>(Запчастини та комплектуючі до електротранспорту)</div>
            </a>
          </li>
          {/* <li>
            <a
              href="tel: +380676161200"
              style={{width: 'fit-content', display: 'block'}}>
              <div>+38 067 616-12-00</div>
              <div>(Бухгалтерія)</div>
            </a>
          </li> */}
        </ul>
      </div>
      <div className="single-product__descriptions-block">
        <h3 className="single-product__descriptions-title">Режим роботи:</h3>
        <ul className="list">
          <li>
            <b>Понеділок:</b> 9:30 - 17:00
          </li>
          <li>
            <b>Вівторок-П'ятниця:</b> 8:30 - 17:00
          </li>
          <li>
            <b>Субота:</b> вихідний
          </li>
          <li>
            <b>Неділя:</b> вихідний
          </li>
          <li>
            <b>Обід:</b> 13.00-14.00
          </li>
          <li style={{whiteSpace: 'nowrap'}}>
            <b>Відвантаження замовлення:</b> до 16:30
          </li>
        </ul>
      </div>
    </div>
  );
};
const tabInfoItems = [
  {
    title: 'Самовивіз з магазину:',
    desc:
      'Ви можете переглянути товар, розрахуватись та детальніше проконсультуватися щодо замовленого товару безпосередньо в офісі нашої компанії в робочий час.',
  },
  {
    title: 'Доставка по Рівному:',
    desc:
      "Кур'єр підвозить замовлення щодня по вказаному в замовленні адресу. Виїзд кур'єра о 14:30 та 17:00. Є мінімальна вартість замовлення! Даталі уточняйте в менеджерів компанії.",
  },
  {
    title: 'Доставка по Україні:',
    subTitle: 'Доставка транспортними компаніями:',
    desc:
      'Вартість доставки згідно тарифів автоперевізників оплачується Замовником. На ваш вибір послуги компаній Нова пошта або САТ. Відправлення здійснюються щодня за умови опрацьованого замовлення до 16:30.',
  },
];

export const TabPaneGetProduct = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabTitles = [
    'Самовивіз з магазину',
    'Доставка по Рiвному',
    'Доставка по Україні',
  ];
  const tabItems = [
    renderTabItem(tabInfoItems[0]),
    renderTabItem(tabInfoItems[1]),
    renderTabItem(tabInfoItems[2]),
  ];

  return (
    <div className=" single-product__receipt">
      <ul className="single-product__receipt-list">
        {tabInfoItems.map((tab, index) => (
          <li
            onClick={() => setActiveTab(index)}
            key={tab.title}
            style={{cursor: 'pointer'}}
            className={clsx(
              'single-product__receipt-item',
              activeTab === index ? 'active' : '',
            )}>
            {tab.title}
          </li>
        ))}
      </ul>
      {tabItems[activeTab]}
    </div>
  );
};
